import { createFileRoute } from '@tanstack/react-router';
import { Intercompany } from '@/features/insights/Intercompany';

export const Route = createFileRoute('/_app/intercompany')({ component: Intercompany });
